import React from "react";
import Link from "next/link";
import { mockPosts } from "../../mock";
import { InstagramPostsProps } from "../../props";
import styles from "./sw-instagram-variant-01.module.scss";
import {
  PlatformsIcon,
  PlatformsImage,
} from "@/components/package-components/non-editable/core";

export const InstagramPostsVariant01 = (props: InstagramPostsProps) => (
  <section className={`${styles.section}`}>
    <div className={`${styles.container}`}>
      <h1 className={`${styles.title} title-${props.id}`}>
        Confira nosso{" "}
        <Link
          href={`https://${props.instagramUrl}`}
          target="_blank"
          rel="nofollow"
        >
          <span>Instagram</span>
        </Link>
      </h1>
      <div className={styles.instagram__gallery}>
        {mockPosts.data.map((post, index: number) => (
          <Link
            href={post.permalink}
            target="_blank"
            key={index}
            className={`${styles.instagram__post} ${
              index === 0 ? styles.big : ""
            }`}
          >
            <PlatformsImage
              preload
              src={post.media_url}
              alt={`Imagem Principal do veículo`}
              className="w-full h-full object-center object-cover"
              width={1720}
              height={1080}
            />
            <div className={`${styles.post__content}`}>
              <div className={`${styles.content__icons}`}>
                <PlatformsIcon
                  className={`${styles.icon}`}
                  icon="fe:instagram"
                  width={20}
                  height={20}
                />
                <PlatformsIcon
                  className={`${styles.icon}`}
                  icon="ri:heart-line"
                  width={20}
                  height={20}
                />
              </div>
              <div className={`${styles.post__description}`}>
                <p>{post.caption}</p>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  </section>
);
